import { render, staticRenderFns } from "./demandOrder.vue?vue&type=template&id=40d48072"
import script from "./demandOrder.vue?vue&type=script&lang=js"
export * from "./demandOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports